var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.406,
    height: 25.206,
    viewBox: "0 0 23.406 25.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconParkEscalators",
    transform: "translate(-3.5 -3.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_530",
    "data-name": "Groupe 530",
    transform: "translate(4 9.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_258",
    "data-name": "Trac\\xE9 258",
    d: "M21.364,13,9.041,26.2H4v5.4H9.041L21.364,18.4h5.041V13Z",
    transform: "translate(-4 -13)",
    fill: "#c52b30",
    stroke: "#c52b30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_261",
    "data-name": "Trac\\xE9 261",
    d: "M10.041,18,5,23.4",
    transform: "translate(-4.44 -15)",
    fill: "none",
    stroke: "#c52b30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_262",
    "data-name": "Trac\\xE9 262",
    d: "M8.361,24.6H5V21",
    transform: "translate(-4.44 -16.2)",
    fill: "none",
    stroke: "#c52b30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_529",
    "data-name": "Groupe 529",
    transform: "translate(12.402 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_259",
    "data-name": "Trac\\xE9 259",
    d: "M19,9.4,24.041,4",
    transform: "translate(-19 -4)",
    fill: "none",
    stroke: "#c52b30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_260",
    "data-name": "Trac\\xE9 260",
    d: "M22,4h3.361V7.6",
    transform: "translate(-20.32 -4)",
    fill: "none",
    stroke: "#c52b30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtageIcon);
export default __webpack_public_path__ + "static/media/EtageIcon.7a887d16e143de06adf897a522e0d6d9.svg";
export { ForwardRef as ReactComponent };